import React, { FC, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Tree } from "./checkbox-tree2";

interface CheckboxNode2Props {
    tree: Tree;
    onChange: (e: React.ChangeEvent<HTMLInputElement>, node: Tree) => void,
    onExpand: (node: Tree) => void
}

const CheckboxNode2: FC<CheckboxNode2Props> = ({ tree, onChange, onExpand }) => {
    const { translate } = useLocale();
    const [expand, setExpand] = useState(false);
    const nodeTypePrefix = tree.key ? `${translate.byKey(TranslationKeys[tree.key])}:` : null;

    const onLocalExpand = async () => {
        onExpand(tree);
        setExpand(exp => !exp);
    }
    
    return <div className="border-l">
        <div className="flex">
            <svg onClick={onLocalExpand} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`${tree.canExpand ? '' : 'invisible'} w-6 h-5  cursor-pointer transform transition-transform duration-300 ${expand === false ? "rotate-360" : "rotate-90"}`}>
                <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
            {tree.icon ? <span className="w-4 mr-2 text-slate-500 text-center">
                <FontAwesomeIcon icon={tree.icon} />
            </span> : null}
            {tree.clickable ? <input type="checkbox" className="ml-1 mr-3" checked={tree.checked} onChange={(e) => onChange(e, tree)} /> : null}
            <span>
                {nodeTypePrefix ? <span className="text-slate-500 mr-1">{nodeTypePrefix}</span> : null}
                <span>{tree?.label}</span>
            </span>

        </div>
        {expand ? tree?.children?.map((child, i) => {
            return <div key={child.id} className="ml-3">
                <CheckboxNode2 tree={child} onChange={onChange} onExpand={onExpand} />
            </div>
        }) : null}
    </div>
}

export default CheckboxNode2;